// guides/actionCreators.js

import actionTypes from './actionTypes';

//public actions
const requestGuidesData = () => ({
    type: actionTypes.REQUEST_GUIDES_DATA
});

const guidesDataResponse = (success, season, guidesData, errors) => ({
    type: actionTypes.GUIDES_DATA_RESPONSE,
    payload: {
        success: success,
        season: season,
        guides: guidesData.data,
        errors: errors
    }
});

const guidesDataByTeam = (teamId) => ({
    type: actionTypes.GUIDES_BY_TEAM,
    payload: {
        guidesByTeam: teamId
    }
});

export default {
    requestGuidesData,
    guidesDataResponse,
    guidesDataByTeam
};